// extracted by mini-css-extract-plugin
export default {"image":"TBOI0Q"};